import React from 'react';
import { HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { AppColors, AppConst } from 'helpers';
import { useAppSetting } from 'helpers/useAppSetting';
import { TextDisplay } from 'vendor-deprecated/Text';
import { Image } from 'components/common/vendors/Image';

export const BannerDownloadApp = () => {
  const { appTheme, appSize, appLayout } = useAppSetting();
  if (!appLayout.isMobile) {
    return null;
  }

  return (
    <VerticalView
      fullWidth
      position={'fixed'}
      padding={'5px'}
      width={'100%'}
      alignContent={'center'}
      bottom={'0px'}
      zIndex={AppConst.zIndex.header}
      background={AppColors.BLACK}
    >
      <TextDisplay id={'public.home.application.message'} size={appSize.h4} color={appTheme.base.white} />
      <HorizontalView padding={'5px'}>
        <HorizontalView
          flexWrap={'nowrap'}
          cursor={'pointer'}
          onClick={() => {
            window.open(AppConst.application.ios);
          }}
        >
          <Image
            width={'80px'}
            src={appLayout.isMobile ? '/apple-store-mobile.png' : '/apple-store.png'}
            objectFit={'contain'}
          />
        </HorizontalView>

        <HorizontalView
          marginLeft={'25px'}
          flexWrap={'nowrap'}
          cursor={'pointer'}
          onClick={() => {
            window.open(AppConst.application.android);
          }}
        >
          <Image
            width={'80px'}
            src={appLayout.isMobile ? '/google-play-mobile.png' : '/google-play.png'}
            objectFit={'contain'}
          />
        </HorizontalView>
      </HorizontalView>
    </VerticalView>
  );
};
